import type { ViewComponent } from "@frui.ts/views";
import type SubLedgerNewReportViewModel from "../../../../viewModels/finance/subLedger/SubLedgerNewReportViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import React from "react";
import { Input } from "@frui.ts/bootstrap";
import { translateGeneral } from "../../../../utils/localizations";
import AccountNumberOrIbanAndBankCodeInput from "../../../../controls/finance/accountNumberOrIbanAndBankCodeInput";

export const TransferParameters: ViewComponent<SubLedgerNewReportViewModel> = observer(({ vm }) => {
  return (
    <div style={{ paddingBottom: "2.5rem" }}>
      <h5>{vm.translate("transferParameters.name")}</h5>

      <div className="row">
        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{translateGeneral("bankAccountNumber")}*</Form.Label>
          <AccountNumberOrIbanAndBankCodeInput
            target={vm.transfer}
            property="bankAccount"
            mode="object"
            placeholder={translateGeneral("bankAccountNumber")}
            disabled={!vm.canEditTransfer}
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("transferParameters.variableSymbol")}*</Form.Label>
          <Input
            target={vm.transfer}
            property="variableSymbol"
            placeholder={vm.translate("transferParameters.variableSymbol")}
            type="number"
            disabled={!vm.canEditTransfer}
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("transferParameters.constantSymbol")}*</Form.Label>
          <Input
            target={vm.transfer}
            property="constantSymbol"
            placeholder={vm.translate("transferParameters.constantSymbol")}
            type="number"
            disabled={!vm.canEditTransfer}
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("transferParameters.specificSymbol")}*</Form.Label>
          <Input
            target={vm.transfer}
            property="specificSymbol"
            placeholder={vm.translate("transferParameters.specificSymbol")}
            type="number"
            disabled={!vm.canEditTransfer}
          />
        </Form.Group>
      </div>
    </div>
  );
});
